import React from 'react';
import { HelpCenterSettingsRedirect } from '@atlassian/jira-servicedesk-customer-service-common/src/ui/help-center-settings-redirect/index.tsx';
import type { KBSettingsAppWithLayout as ProjectSettingsServiceDeskKnowledgeBaseV2Type } from '@atlassian/jira-spa-apps-knowledge-settings/src/ui/index.tsx';
import type SettingsServiceDeskKnowledgeBaseType from '@atlassian/jira-spa-apps-project-settings-service-desk-knowledge-base/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const NEXTGEN_SETTINGS = 'project/service-desk/settings/index';
export const CLASSIC_SETTINGS = 'project/service-desk/settings';

export const LazySettingsServiceDeskKnowledgeBase = lazyForPaint<
	typeof SettingsServiceDeskKnowledgeBaseType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-knowledge-base", jiraSpaEntry: "async-project-settings-service-desk-knowledge-base" */ '@atlassian/jira-spa-apps-project-settings-service-desk-knowledge-base'
		),
);

export const LazyProjectSettingsServiceDeskKnowledgeBaseV2 = lazyForPaint<
	typeof ProjectSettingsServiceDeskKnowledgeBaseV2Type
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-knowledge-base-v2", jiraSpaEntry: "async-project-settings-service-desk-knowledge-base-v2" */ '@atlassian/jira-spa-apps-knowledge-settings'
		),
	),
);

export const ServiceDeskKnowledgeBaseV2 = () => (
	<HelpCenterSettingsRedirect page="kb">
		<LazyPage
			Page={LazyProjectSettingsServiceDeskKnowledgeBaseV2}
			pageId="project-settings-knowledge-base"
			shouldShowSpinner
		/>
	</HelpCenterSettingsRedirect>
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazySettingsServiceDeskKnowledgeBase}
		pageId="project-settings-knowledge-base"
		shouldShowSpinner
	/>
);
